'use strict';
import actionTypes from '../actionTypes';

const initialState = {
    panels: []
};

function panelsReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.FETCH_PANELS: {
            return Object.assign({}, state, {
                panels: action.payload
            });
        }
        default:
            return state;
    }
}

export { panelsReducer };

export default {
    panelsReducer: panelsReducer
};
